import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18896
// Убираем кнопку "Очистить" в модалке и растяжке
export const overquotaAbNoClear: 'a' | 'b' | undefined = getFeature('overquota-ab-no-clear');
